var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRInviteDiscF2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-invite-disc-f2",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.758,9.988c-2.121,-0 -4.592,1.909 -5.139,10.339c-0.506,-1.655 -1.861,-2.914 -3.551,-3.297l-4.283,-0.972c-1.401,-0.323 -2.873,0.005 -4.006,0.887l-2.65,2.047c-0.575,0.438 -0.678,1.265 -0.233,1.84c0.445,0.575 1.265,0.678 1.84,0.234l2.647,-2.047c0.52,-0.397 1.19,-0.54 1.827,-0.404l0.816,0.185l-1.937,4.784c-0.569,1.396 -0.035,2.997 1.259,3.77l4.584,2.771c0.13,0.089 0.205,0.226 0.212,0.376c-0,0.041 -0.007,0.082 -0.014,0.123l-1.827,5.713c-0.093,0.334 -0.055,0.695 0.115,0.996c0.171,0.308 0.452,0.534 0.787,0.63c0.127,0.027 0.242,0.049 0.363,0.049c0.588,0 1.101,-0.39 1.265,-0.951l1.82,-5.72c0.383,-1.334 -0.178,-2.75 -1.362,-3.469l-2.835,-1.71l2.299,-5.731c0.151,0.192 0.274,0.418 0.349,0.657l0.767,2.518c0.39,1.293 1.567,2.135 2.921,2.141l2.646,0.005c0.723,-0 1.32,-0.592 1.32,-1.309c-0,-0.725 -0.582,-1.286 -1.314,-1.292l-1.307,-0c0.054,-5.889 1.241,-10.536 2.621,-10.536c1.45,0 2.627,5.097 2.627,11.385c-0,6.288 -1.177,11.385 -2.627,11.385c-1.171,-0 -2.156,-3.312 -2.498,-7.882l-2.655,0c0.336,5.37 1.589,10.509 5.153,10.509c2.394,0 5.254,-2.429 5.254,-14.012c0,-6.393 -0.908,-14.012 -5.254,-14.012Zm-7.882,5.254c1.45,0 2.627,-1.176 2.627,-2.578c0,-1.401 -1.177,-2.676 -2.627,-2.676c-1.451,-0 -2.628,1.177 -2.628,2.627c-0,1.451 1.177,2.627 2.628,2.627Zm-7.986,12.091l-1.089,2.529c-0.066,0.164 -0.225,0.268 -0.394,0.268l-4.105,0c-0.726,0 -1.314,0.591 -1.314,1.314c-0,0.722 0.588,1.314 1.314,1.314l4.105,-0c1.225,-0 2.332,-0.733 2.818,-1.812l0.739,-1.774l-0.52,-0.321c-0.629,-0.385 -1.154,-0.905 -1.554,-1.518Z",
    style: {
      fill: "#f2f2f2",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRInviteDiscF2);
export default __webpack_public_path__ + "static/media/iconR-invite-disc-f2.cd54ce1db32d08739a02ddf6bf274698.svg";
export { ForwardRef as ReactComponent };